import countryPickerUrl from './countryPicker.html';

class CountryPickerCtrl {
  constructor(Authentication, Utils, sdk) {
    'ngInject';

    Object.assign(this, { Authentication, Utils, sdk });
  }

  $onInit() {
    this.countries = this.sdk('countries');

    if (this.useValueForDisplay) {
      this.mappedCountries = this.sdk('countries').map((i) => ({
        value: i,
        label: i.label,
        toggleLabel: i.value,
      }));
    }

    this.setCountryCodeData();
  }

  $onChanges() {
    this.setCountryCodeData();
  }

  setCountryCodeData() {
    this.countryCodeData = this.Utils.getCountryCodeData(
      this.countryCode,
      this.countryIsoCode,
      this.geo,
      this.useAuthData && this.Authentication.user,
      this.countries
    );
    this.onCountrySelect({ countryCodeData: this.countryCodeData });
  }

  selectCountryCode = (value) => {
    if (this.useValueForDisplay) {
      this.onCountrySelect({ countryCodeData: value });
    } else {
      this.onCountrySelect({ countryCodeData: this.countryCodeData });
    }
  };
}

export default {
  bindings: {
    countryCode: '<?',
    countryIsoCode: '<?',
    geo: '<',
    useAuthData: '<?',
    readOnly: '<?',
    onCountrySelect: '&',
    useValueForDisplay: '<?',
  },
  templateUrl: countryPickerUrl,
  controller: CountryPickerCtrl,
  controllerAs: 'ctrl',
};
